const permissionList = {
    admin: "admin",
    statistics: "statistics",
    announcements: "announcements",
    complexQuery: "complexQuery",
    scenarioSave: "scenarioSave",
    scenarioAdmin: "scenarioAdmin",
    singleQuery: "singleQuery",
    globalQuery: "globalQuery",
    comparisonQuery: "comparisonQuery",
    geographicalAnalysis: "geographicalAnalysis",
    multiAlertAssign: "multiAlertAssign",
    faceQuery: "faceQuery",
    htsQuery: "htsQuery",
    bankQuery: "bankQuery",
    queryWarnings: "queryWarnings",
    treeViewPreparedQuery: "treeViewPreparedQuery",
    atsQuery: "atsQuery",
    onlineUsers: "onlineUsers",
    authorization: "authorization",
    singleQuerySecondCombobox: "singleQuerySecondCombobox",
    tableButtons: "tableButtons",
    notifications: "notifications",
    dashboardWholeExpand: "dashboardWholeExpand",
    singleQueryPermissionForDescription: "singleQueryPermissionForDescription",
    scenarioApprove: "scenarioApprove",
    faceQueryScenario: "faceQueryScenario",
    faceQueryScenarioAdmin: "faceQueryScenarioAdmin",
    autoAlertAssignUser: "autoAlertAssignUser",
    autoAlertAssignAdmin: "autoAlertAssignAdmin",
    globalQueryReport: "globalQueryReport",
    heatMapQuery: "heatMapQuery",
    sib: "sib",
    sibAdmin: "sibAdmin",
    sibScoring: "sibScoring",
    sibTrackingAdmin: "sibTrackingAdmin",
    sibTrackingUser: "sibTrackingUser",
    sibDynamicDescriptionAdmin: "sibDynamicDescriptionAdmin",
    sibDynamicDescriptionUser: "sibDynamicDescriptionUser",
    sibTrackingOutSourceBtn: "sibTrackingOutSourceBtn",
    sibTrackingRdAlerts: "sibTrackingRdAlerts",
    complexQueryServiceEntities: "complexQueryServiceEntities",
    intelligenceData: "intelligenceData",
    intelligenceDataAdmin: "intelligenceDataAdmin",
    caseManagement: "caseManagement",
    caseManagementAdmin: "caseManagementAdmin",
    chat: "chat",
    notebook: "notebook",
    dataBinding: "dataBinding",
    dataBindingApprove: "dataBindingApprove",
    alertAdmin: "alertAdmin",
    alertUser: "alertUser",
    timeElapsedGroupedAlertsTab: "timeElapsedGroupedAlertsTab",
    writableData: "writableData",
    writableDataAdmin: "writableDataAdmin",
    storedCommunicationQuery: "storedCommunicationQuery",
    preparedQuery: "preparedQuery",
    preparedQueryAdmin: "preparedQueryAdmin",
    serviceQuery: "serviceQuery",
    fibaFraudList: "fibaFraudList",
    fibaCustomerWarnings: "fibaCustomerWarnings",
    fibaTrapPhoneEmail: "fibaTrapPhoneEmail",
    fibaTrapEmail: "fibaTrapEmail",
    fibaAccountHold: "fibaAccountHold",
    fibaChannelOpenClose: "fibaChannelOpenClose",
    fibaCustomerMonitoring: "fibaCustomerMonitoring",
    importFile: "importFile",
    preparedQueryExcelExport: "preparedQueryExcelExport",
    parallelQuery: "parallelQuery",
    dqlOperations: "dqlOperations",
    systemManagement: "systemManagement",
    dashboardBtn: "dashboardBtn",
    catchingAdmin: "catchingAdmin",
    recurrence: "recurrence",
    resultEntityQuery: "resultEntityQuery",
    kycRule: "kycRule",
    kycScore: "kycScore",
    kycAlarm: "kycAlarm",
    kycRfi: "kycRfi",
    kycRfi: "kycRfi",
    kycAlarmManagement: "kycAlarmManagement",
    kycRfiManagement: "kycRfiManagement",
    informationRequest: "informationRequest",
    informationRequestAdmin: "informationRequestAdmin",
    showOnMap: "showOnMap",
    schemaMapTab: "schemaMapTab",
    showPtsPhotos: "showPtsPhotos",
    roadMapAnalysis: "roadMapAnalysis",
    geographicalAnalysisForBank: "geographicalAnalysisForBank",
    customerDetail: "customerDetail",
    navbarOpenButton: "navbarOpenButton",
    emptySchema: "emptySchema",
    autoSavedAnalysis: "autoSavedAnalysis",
    fraudQueriesMenuHeader: "fraudQueriesMenuHeader",
    sibOneFour: "sibOneFour",
    sibTwoZero: "sibTwoZero",
    sibExcelUpload: "sibExcelUpload",
    sibCustomerDetailAnalysis: "sibCustomerDetailAnalysis",
    reduceFalsePositive: "reduceFalsePositive",
    similarCustomer: "similarCustomer",
    preparedQueryIsAsync: "preparedQueryIsAsync",
    fibaMailAdmin: "fibaMailAdmin",
    dtgraph: "dtgraph",
    dtgraphAdmin: "dtgraphAdmin",
    alertMLColumnPermission: "alertMLColumnPermission",
    downloadPdf: "downloadPdf",
    advancedFilter: "advancedFilter",
    addDqlFilter: "addDqlFilter",
    predefinedFilter: "predefinedFilter",
    informationCard: "informationCard",
    compoundQuery: "compoundQuery",
    digitalTraces: "digitalTraces",
    integratedQuery: "integratedQuery",
    faceRecognition: "faceRecognition",
    containerQuery: "containerQuery",
    queryTemplateRoles: "queryTemplateRoles",
    spaceGraph: "spaceGraph",
    editAggregationFormulas: "editAggregationFormulas",
    asyncQuery: "asyncQuery",
    examUser: "examUser",
    examAdmin: "examAdmin",
    scenarioSummary: "scenarioSummary",
    excelManager: "excelManager",
    logRecords: "logRecords",
    parsLogRecords: "parsLogRecords",
    kepLogRecords: "kepLogRecords",
    kafesLogRecords: "kafesLogRecords",
    whiteListLogRecords: "whiteListLogRecords",
    sqlQuery: "sqlQuery",
    obligation: "obligation",
    notificationAdmin: "notificationAdmin",
    plateTrackingAdmin: "plateTrackingAdmin",
    trackingWarningAdmin: "trackingWarningAdmin",
    incident: {
        main: "fraud.incidentmanagement",
        admin: "fraud.incidentmanagement.admin",
        callServices: "fraud.incidentmanagement.callservices",
        updateStatus: "fraud.incidentmanagement.updatestatus",
        updateAssignee: "fraud.incidentmanagement.updateassignee",
        addToCase: "fraud.incidentmanagement.addtocase",
        excel: "fraud.incidentmanagement.excel",
        goToDetail: "fraud.incidentmanagement.gotodetail",
        detailEdit: "fraud.incidentmanagement.detailedit"
    },
    case: {
        main: "fraud.casemanagement",
        admin: "fraud.casemanagement.admin",
        excel: "fraud.casemanagement.excel",
        updateStatus: "fraud.casemanagement.updatestatus",
        updateAssignee: "fraud.casemanagement.updateassignee",
        detailEdit: "fraud.casemanagement.detailedit",
        goToDetail: "fraud.casemanagement.gotodetail"
    },
    rule: {
        main: "fraud.rule",
        active: "fraud.rule.active",
        editRule: "fraud.rule.editrule",
        deleteRule: "fraud.rule.deleterule",
        createCandidate: "fraud.rule.createcandidate",
        waiting: "fraud.rule.waiting",
        editCandidate: "fraud.rule.editcandidate",
        deleteCandidate: "fraud.rule.deletecandidate",
        approveOrRejectCandidate: "fraud.rule.approverejectcandidate",
        compareQuery: "fraud.rule.comparequery"
    },
    ruleSet: {
        main: "fraud.ruleset",
        create: "fraud.ruleset.create",
        edit: "fraud.ruleset.edit",
        delete: "fraud.ruleset.delete"
    },
    ruleSetRule: {
        main: "fraud.rulesetrule",
        create: "fraud.rulesetrule.create",
        edit: "fraud.rulesetrule.edit",
        delete: "fraud.rulesetrule.delete",
    },
    ruleSetMapping: {
        main: "fraud.rulesetmapping",
        create: "fraud.rulesetmapping.create",
        edit: "fraud.rulesetmapping.edit",
        delete: "fraud.rulesetmapping.delete"
    },
    ruleSetResponse: {
        main: "fraud.rulesetresponse",
        create: "fraud.rulesetresponse.create",
        edit: "fraud.rulesetresponse.edit",
        delete: "fraud.rulesetresponse.delete",
    },
    systemSettings: {
        main: "fraud.systemsettings",
        responseType: "fraud.responsetype",
        ruleSetType: "fraud.rulesettype",
        serviceResponse: "fraud.serviceresponse",
        serviceResponseTransition: "fraud.serviceresponsetransition",
        incidentState: "fraud.incidentstate",
        incidentStateTransition: "fraud.incidentstatetransition",
        caseState: "fraud.casestate",
        caseStateTransition: "fraud.casestatetransition"
    },
    actionManagement: {
        main: "fraud.actionmanagement",
        actions: "fraud.actionmanagement.actions",
        actionEntityMapping: "fraud.actionmanagement.actionentitymapping"
    }
}


export default permissionList;